// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"140":"80835065","245":"3be16bbc","274":"48244fcf","293":"1023aac5","307":"cbb10feb","562":"07c6da04","787":"09b0e574","856":"ae9167f6"}[chunkId] + ".chunk.js";
};